export const MainCommercialInteriorPainting = {
    "imageUrl": "/assets/imgs/services/5CommercialInteriorPainting/fondo.png",
    "eyebrow": "Commercial Interior",
    "title": "Painting",
    "headingSpan": "ELEVATE YOUR SPACE WITH",
    "heading": "PRECISION & QUALITY",
    "description": "A well-executed interior paint job enhances your building’s aesthetic appeal, professional image, and overall ambiance, while also protecting surfaces from wear and tear. At HRD Painting & Restoration, we deliver high-quality commercial interior painting with a focus on durability, flawless finishes, and minimal disruption to your business operations.",
    "highlightSpan": "The best Building Envelope Renewal",
    "highlight": " / High-Rise Painting & Restoration services.",
    "button": {
        "text": "Request a Quote",
        "url": "/quote"
    }
};